import ReactHtmlParser from "react-html-parser";

const lowSOP = `<div>
    <div style="margin-top: 20px;margin-bottom: 20px">
        These alerts will only generate when the volume in the alert bucket is above a threshold that we believe is normal for the time remaining in the CPT. These will only alert when the site must change how they are processing to ensure there are no negative impact to customers (Lates)
    </div>
    <strong>Steps:</strong></br>
    <ol>
        <li>Understand why the alert was created and where the packages are at on the floor. For HELD packages, these are typically found in a cart near the induct station, or the end of the conveyance line at Jackpot
        </li>
        <li>Once packages are located, assign an AA to unload packages onto the conveyance at Induct. Evaluate the need to increase Induct staffing based on the number of packages</li>
        <li>Continue to monitor the alert bucket to ensure the actions taken on site are driving down the volume in that bucket</li>
    </ol>
</div>`;

const mediumSOP = `<div>
    <div style="margin-top: 20px;margin-bottom: 20px">
        These alerts will only generate when the volume in the alert bucket is above a threshold that we believe is normal for the time remaining in the CPT. These will only alert when the site must change how they are processing to ensure there are no negative impact to customers (Lates)
    </div>
    <strong>Steps:</strong></br>
    <ol>
        <li>Understand why the alert was created and where the packages are at on the floor. For HELD packages, these are typically found in a cart near the induct station, or the end of the conveyance line at Jackpot.
        </li>
        <li>Acknowledge the alert in HAWK. This must be done within 15 minutes of CPT.</li>
        <li>Once packages are located, assign an AA to unload packages onto the conveyance at Induct. Evaluate the need to increase Induct staffing based on the number of packages.</li>
        <li>Continue to monitor the alert bucket to ensure the actions taken on site are driving down the volume in that bucket.</li>
    </ol>
</div>`;

const highSOP = `<div>
    <div style="margin-top: 20px;margin-bottom: 20px">
        Late alerts are generated after latest time to complete this process per the Ops Clock. These will only generate when the volume in the alert bucket is above a threshold that we believe is normal. This bucket is directly related to Late metrics. These alerts are generally used for bridging, since there are no actions that can be taken to address these and not have the packages be late.
    </div>
    <strong>Steps:</strong></br>
    <ol>
        <li>Understand why the alert was created and where the packages are at on the floor. For HELD packages, these are typically found in a cart near the induct station, or the end of the conveyance line at Jackpot
        </li>
        <li>Deep dive the alerts by using the "Copy TBAs" and "SCC" buttons in the HAWK tool. Since these packages are already late, they are typically not changing quickly in the alert, so a deep dive can help you understand where the package is and why it is late.</li>
        <li>Complete the actions that were identified from the deep dive to resolve any issues for the package or process that led to these packages being late. The alert will be removed from HAWK once all packages are processed and no longer in that bucket.</li>
        <li>Bridge the alert in HAWK using the notes function. These bridges will be used by leadership for DBR/WBRs to explain why this alert was triggered and what was done to resolve.</li>
        <li>Continue to monitor the alert bucket to ensure the actions taken on site are driving down the volume in that bucket.</li>
    </ol>
</div>`;

export default (sopParameters) => {
  const { criticality } = sopParameters || {};
  const sopContent = criticality === "high" ? highSOP : criticality === "medium" ? mediumSOP : lowSOP;
  const level = (criticality || "low").charAt(0).toUpperCase() + (criticality || "low").slice(1);
  return ReactHtmlParser(
    `<div>
  <h2>SSD NPLB Held Site - ${level}</h2>
  <h3>Description</h3>
  <p>Packages that are dwelling in held</p>
  <h3>SOP</h3>
  ${sopContent}
</div>`
  );
};



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_NPLB_Held_Site.jsx